import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserDrawersService } from './browser-drawers.service';
import { DrawersService } from '@shared/shared/drawers/common/abstracts/drawers.service';
import { BrowserDrawerComponentModule } from '@shared/shared/drawers/browser/browser-drawers/internal/browser-drawer/browser-drawer.component.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, BrowserDrawerComponentModule]
})
export class BrowserDrawersModule {
  static forRoot(): ModuleWithProviders<BrowserDrawersModule> {
    return {
      ngModule: BrowserDrawersModule,
      providers: [{ provide: DrawersService, useClass: BrowserDrawersService }]
    };
  }
}
